import React, {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {useRecoilState} from "recoil";
import {unitsAtom, unitsEnumAtom} from "../../state/rentalPeriodsRecoil";
import {currencyAtom} from "../../state/constantsRecoil";
import {fromGenericBeToGenericFe, fromRateBeToFe, i18nConvertNumberWithDecimals,} from "../../utils";
import {SET_SNACKBAR} from "../../constants";
import {
    buildEntityRequestFromFormValues,
    buildRateBaseDefinitionValues,
    getRateBaseDefinitionValidationSchema,
    initialRateBaseDefinitionValues,
} from "./BaseDefinition/RateBaseDefinitionForm";
import {rateSelectListAtom} from "../../state/ratesRecoil";
import {useLocation, useParams} from "react-router-dom";
import RateBaseDefinition from "./BaseDefinition/RateBaseDefinition";
import RateMatrix from "./Matrix/RateMatrix";
import DialogComponent from "../../common/components/DialogComponent";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {useRateRepository} from "../../api/repositories/RateRepository";
import {useConstantsRepository} from "../../api/repositories/ConstantsRepository";
import {useCommercialCategoryRepository} from "../../api/repositories/CommercialCategoryRepository";
import Loading from "../../common/components/Loading";
import {FormProvider, useForm} from "react-hook-form";
import {Box, Grid, Tab, Tabs} from "@mui/material";
import {useTranslation} from "react-i18next";
import {
    DialogInterface,
    GenericInterface,
    SelectElementModelBE,
    SelectElementModelFE,
    UseLocationStateModel,
} from "../../api/types/generic";
import {FormRateModel, RateEntityRequest, RateEntityResponse, RateSelectFE,} from "../../api/types/rate";
import {commercialCategoryListAtom} from "../../state/commercialCategoriesRecoil";
import {useConfigurationRepository} from "../../api/repositories/ConfigurationRepository";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {CommercialCategoryEntityResponse, CommercialCategorySelectFE,} from "../../api/types/commercialCategory";
import {useCommercialSegmentRepository} from "../../api/repositories/CommercialSegmentRepository";
import {commercialSegmentListAtom} from "../../state/commercialSegmentsAtom";
import i18n from "i18next";
import {useRentalPeriodRepository} from "../../api/repositories/RentalPeriodRepository";
import {RouteParams} from "../../api/types/ancillary";


type TabPanelProps = {
    children?: React.ReactNode;
    index: number;
    value: number;
};

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{p: 3}}>{children}</Box>}
        </div>
    );
}

// TODO CONTROLLARE IL PULSANTE + PERCHE NON CARICA IL FORM E AGGIUNGERE IL WINDOWS.CLOSE SUL CANCEL DELLA MATRICE
const RateContent = ({readOnly, rateId}: { readOnly: boolean, rateId?: number }) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Location
    const location = useLocation();

    const {id} = useParams<RouteParams>();

    const locationState: UseLocationStateModel = location.state as UseLocationStateModel;

    // Use Recoil
    const [, setCommercialCategoryList] = useRecoilState(
        commercialCategoryListAtom
    );
    const [, setCommercialSegmentList] = useRecoilState(
        commercialSegmentListAtom
    );
    const [, setRateSelectList] = useRecoilState(rateSelectListAtom);
    const [, setUnits] = useRecoilState(unitsAtom);
    const [, setUnitsEnum] = useRecoilState<string[]>(unitsEnumAtom);
    const [, setCurrencies] = useRecoilState(currencyAtom);

    // Use State
    const [providers, setProviders] = useState<SelectElementModelFE[]>([]);
    const [rate, setRate] = useState<RateEntityResponse | null>(null);
    const [rateBaseDefinitionValues, setRateBaseDefinitionValues] = useState<FormRateModel | null>(null);
    const [originalRateBaseDefinitionValues, setOriginalRateBaseDefinitionValues] = useState<FormRateModel | null>(null);
    const [value, setValue] = useState<number>(0);
    const [dialog, setDialog] = useState<DialogInterface | null>(null);
    const [rateInUse, setRateInUse] = useState<boolean>(false);
    const [limits, setLimits] = useState<GenericInterface>({});
    const [rateIsFather, setRateIsFather] = useState<boolean>(false)

    // Use Context
    const {
        dispatchGlobalData,
        globalData: {user},
    } = useContext(GlobalContext);

    //setto tutte le legalEntities options e le passo al filtro di ricerca ["all", "drivalia_it","drivalia_fr"]
    const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:legalEntities.'.concat(el.name))
        })
    );

    //se utente clicca su all, mando  ["drivalia_it","drivalia_fr"]
    const optionsFiltered = legalEntityOptions
        .filter(function (el) {
            return el.code !== "all";
        });

    const everyLegalEntitiesWithoutAll = legalEntityOptions
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    //setto tutti i dealers options
    const dealerOption: SelectElementModelFE[] = user.dealers?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:dealers.'.concat(el.name))
        })
    );

    const dealerFilteredOptions = dealerOption
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    // Use Repository Hooks
    const {getRate, getRateInUse, getLinkableRates, putRate, postRate} = useRateRepository();
    const {getCurrencies} = useConstantsRepository();
    //const {getTpUnits} = useTpUnitRepository();
    //const {getTpUnitsEnum} = useConstantsRepository();
    const {getTpUnitsEnumNoAbsolute} = useRentalPeriodRepository();
    const {getCommercialCategories} = useCommercialCategoryRepository();
    const {getCommercialSegments} = useCommercialSegmentRepository();
    const {getConfigurationParameter} = useConfigurationRepository();
    //const {getProviders} = useProviderRepository();
    const {getRateIsFather} = useRateRepository();

    const handleSubmit = async (values: FormRateModel) => {
        const rateEntityRequest: RateEntityRequest = buildEntityRequestFromFormValues(values, everyLegalEntitiesWithoutAll, dealerFilteredOptions);
        let notDateFieldsAreUpdated;
        // UPDATE RATE BASE
        if (originalRateBaseDefinitionValues && rateBaseDefinitionValues) {
            const updateRate: RateEntityResponse = {id: Number(rateBaseDefinitionValues?.id), ...rateEntityRequest};
            if (rate) {
                notDateFieldsAreUpdated = checkValues({
                    ...rate,
                    tpPaymentType: {id: 1, name: "Prepaid"}
                }, updateRate);
            }
        }
        if (rate?.id) {
            const rateInFather: boolean = await getRateIsFather(rate?.id as number);
            setRateIsFather(rateInFather)
        }


        setDialog({
            open: true,
            message: rateBaseDefinitionValues?.id ?
                rateInUse && notDateFieldsAreUpdated ?
                    t("pricing:rate.banner")
                    : rateIsFather ? t("pricing:rateMatrix.isFather") :
                        rateIsFather && rateInUse ? t("pricing:rateMatrix.isFatherUsed") :
                            t("pricing:rate.dialogContents.updateRateBase")
                :
                t("pricing:rate.dialogContents.createRateBase"),
            onClickConfirm: () => submit(values, rateEntityRequest)
        });
    };

    // Use Form
    const form = useForm<FormRateModel>({
        defaultValues: rateBaseDefinitionValues || initialRateBaseDefinitionValues,
        resolver: yupResolver(
            getRateBaseDefinitionValidationSchema(t, limits, rate),
            {},
            {
                rawValues: true,
            }
        ),
        shouldUnregister: true,
    });

    const checkValues = (
        originalRateBaseDefinitionValues: RateEntityResponse,
        rateBaseDefinitionValues: RateEntityResponse
    ): boolean => {
        //converti in stringa, assegna a oggetto x non perderli, togliere date da oggetto nuovo, stringare,  confrontare stringhe senza date
        const firstStringOriginalRate = JSON.stringify(
            originalRateBaseDefinitionValues
        );
        const firstStringRate = JSON.stringify(rateBaseDefinitionValues);

        const objectOriginalRate = JSON.parse(firstStringOriginalRate);
        const objectRate = JSON.parse(firstStringRate);

        delete objectOriginalRate.pickupFrom;
        delete objectOriginalRate.pickupTo;
        delete objectOriginalRate.reservationFrom;
        delete objectOriginalRate.reservationTo;

        delete objectRate.pickupFrom;
        delete objectRate.pickupTo;
        delete objectRate.reservationFrom;
        delete objectRate.reservationTo;

        const updatedStringOriginalRate = JSON.stringify(
            Object.entries(objectOriginalRate).sort()
        );
        const updatedStringRate = JSON.stringify(Object.entries(objectRate).sort());

        return updatedStringOriginalRate !== updatedStringRate;
    };

    const submit = async (
        values: FormRateModel,
        rateEntityRequest: RateEntityRequest
    ) => {
        const rate: RateEntityRequest = {
            ...rateEntityRequest,
            relatedDiscountIncreaseFixed:
                rateEntityRequest.relatedDiscountIncreaseFixed
                    ? (
                        Number(
                            Number(
                                rateEntityRequest.relatedDiscountIncreaseFixed
                                    .toString()
                                    .replace(",", ".")
                            ).toFixed(2)
                        ) * 100
                    ).toString()
                    : null,
        };

        try {
            const updateRate: RateEntityResponse = {
                id: Number(rateBaseDefinitionValues?.id),
                ...rate,
                used: rateInUse,
            };

            const persistedRate = rateBaseDefinitionValues?.id
                ? await putRate(updateRate)
                : await postRate(rate);

            // const commercialCategory: CommercialCategorySelectFE = fromSingleGenericBeToSingleGenericFe(rate.commercialCategory) as CommercialCategorySelectFE;
            // const commercialSegment: SelectElementModelFE = fromSingleGenericBeToSingleGenericFe(commercialCategory?.commercialSegment);

            form.reset();
            dispatchGlobalData(SET_SNACKBAR.SUCCESS);
            const newRateBaseDefinitionValues: FormRateModel =
                buildRateBaseDefinitionValues(persistedRate, t);
            setRateBaseDefinitionValues(newRateBaseDefinitionValues);
            setRate(persistedRate);
            // setOriginalCommercialSegment(commercialSegment);
            form.reset(newRateBaseDefinitionValues);

            setDialog(null);
            setValue(1);
        } catch (e) {
        }
    };

    const getStaticContents = async () => {
        try {
            // TODO: togliere COMMERCIAL_CATEGORIES || quando si pusha
            // const commercialCategoriesData: CommercialCategoryEntityResponse[] = COMMERCIAL_CATEGORIES || await getCommercialCategories();
            const commercialCategoriesData: CommercialCategoryEntityResponse[] =
                await getCommercialCategories();

            // TODO: togliere COMMERCIAL_SEGMENTS || quando si pusha
            // const commercialSegmentsData = COMMERCIAL_SEGMENTS || await getCommercialSegments();
            const commercialSegmentsData = await getCommercialSegments();

            const tpUnitsData = await getTpUnitsEnumNoAbsolute();
            const currenciesData = await getCurrencies();
            //const providersData = await getProviders();

            const commercialCategoryList: CommercialCategorySelectFE[] =
                fromGenericBeToGenericFe(commercialCategoriesData);
            setCommercialCategoryList(commercialCategoryList);

            setUnitsEnum(tpUnitsData);

            const commercialSegmentList: SelectElementModelFE[] =
                fromGenericBeToGenericFe(commercialSegmentsData);
            setCommercialSegmentList(commercialSegmentList);

            //const providersList: SelectElementModelFE[] = fromGenericBeToGenericFe(providersData);
            //setProviders(providersList);

            setCurrencies(currenciesData);

            const rateDurationMin = await getConfigurationParameter({
                parameter: "rateDurationMin",
            });
            const rateDurationMax = await getConfigurationParameter({
                parameter: "rateDurationMax",
            });
            const rateMinLateTolerance = await getConfigurationParameter({
                parameter: "rateMinLateTolerance",
            });
            const rateAdvancedBookingThreshold = await getConfigurationParameter({
                parameter: "rateAdvancedBookingThreshold",
            });

            setLimits({
                rateDurationMin,
                rateDurationMax,
                rateMinLateTolerance,
                rateAdvancedBookingThreshold,
            });

            if ((locationState?.rateId || rateId || id) && !rateBaseDefinitionValues?.id) {
                const rate = await getRate(id || locationState?.rateId || rateId || -1);

                // const commercialCategory: CommercialCategorySelectFE = fromSingleGenericBeToSingleGenericFe(rate.commercialCategory) as CommercialCategorySelectFE;
                // const commercialSegment: SelectElementModelFE = fromSingleGenericBeToSingleGenericFe(commercialCategory?.commercialSegment);

                // if (commercialCategory && rate && commercialSegment) {
                const newRateBaseDefinitionValues: FormRateModel =
                    buildRateBaseDefinitionValues(rate, t);
                setRate(rate);
                // setOriginalCommercialSegment(commercialSegment);
                form.reset(newRateBaseDefinitionValues);
                setRateBaseDefinitionValues(newRateBaseDefinitionValues);
                const originalRateBaseDefinitionValues: FormRateModel = JSON.parse(
                    JSON.stringify(newRateBaseDefinitionValues)
                );

                setOriginalRateBaseDefinitionValues(originalRateBaseDefinitionValues);
                // }
            }
        } catch (e) {
        }
    };

    useEffect(() => {
        const fetchLinkableRates = async () => {
            const selectedLegalEntity = form.getValues("mainDefinition.legalEntity")?.code;
            const selectedDealer = form.getValues("mainDefinition.dealer")?.code;

            if (!selectedLegalEntity || !selectedDealer) {
                setRateSelectList([]);
                return;
            }

            const showOnlyActive = true;
            try {
                // @ts-ignore
                const ratesData = await getLinkableRates(
                    rateBaseDefinitionValues?.id || null,
                    showOnlyActive,
                    // @ts-ignore
                    [selectedDealer],
                    [selectedLegalEntity]
                );
                const rateSelectList: RateSelectFE[] = fromRateBeToFe(ratesData);
                setRateSelectList(rateSelectList);
            } catch (error) {
                console.error("Error fetching linkable rates:", error);
                setRateSelectList([]);
            }
        };

        fetchLinkableRates();
    }, [
        form.watch("mainDefinition.legalEntity"),
        form.watch("mainDefinition.dealer"),
        rateBaseDefinitionValues?.id
    ]);

    // Use Effect
    useEffect(() => {
        getStaticContents();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (rateBaseDefinitionValues?.id) {
            reloadRateDetails();
        }
        // eslint-disable-next-line
    }, [rateBaseDefinitionValues?.id]);

    useEffect(() => {
        if (form.getValues().referenceTariff.discountIncreaseFixed) {
            form.setValue(
                "referenceTariff.discountIncreaseFixed",
                i18nConvertNumberWithDecimals(
                    form.getValues().referenceTariff.discountIncreaseFixed as string
                )
            );
        }
    }, [i18n.language]);

    const reloadRateDetails = async () => {
        try {
            if (rateBaseDefinitionValues?.id) {
                const rateInUse = await getRateInUse(rateBaseDefinitionValues.id);
                setRateInUse(rateInUse);

                const selectedLegalEntity = form.getValues("mainDefinition.legalEntity")?.code;
                const selectedDealer = form.getValues("mainDefinition.dealer")?.code;

                if (!selectedLegalEntity || !selectedDealer) {
                    setRateSelectList([]);
                    return;
                }

                const showOnlyActive = true;
                const ratesData = await getLinkableRates(
                    rateBaseDefinitionValues?.id,
                    showOnlyActive,
                    // @ts-ignore
                    [selectedDealer],
                    [selectedLegalEntity]
                );
                const rateSelectList: RateSelectFE[] = fromRateBeToFe(ratesData);
                setRateSelectList(rateSelectList);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        // click su matrice dei prezzi ma rate non ancora creata
        if (newValue === 1 && !rateBaseDefinitionValues?.id && !readOnly) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t("pricing:rate.dialogContents.createRateMatrix"),
                        type: snackbarTypes.warning,
                        show: true,
                        autoClose: true,
                    },
                },
            });
        } else if (newValue === 0 && !rate?.linkedToReferenceTariff && !readOnly) {
            setDialog({
                open: true,
                message: t("pricing:dialogs.messages.looseChanging"),
                onClickConfirm: () => {
                    setDialog(null);
                    setValue(newValue);
                },
            });
        }
        // click su rate
        else {
            setValue(newValue);
        }
    };

    return (
        <Grid sx={{padding: 0}}>
            <Box sx={{borderBottom: 1, borderColor: "divider"}}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label={t("pricing:rate.title")}/>
                    <Tab label={t("pricing:rateMatrix.title")}/>
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <FormProvider {...form}>
                    <RateBaseDefinition
                        rateInUse={rateInUse}
                        readOnly={readOnly}
                        handleSubmit={form.handleSubmit(handleSubmit)}
                        providers={providers}
                        rate={rate}
                    />
                </FormProvider>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <RateMatrix rateId={rate?.id as number}
                            rateInUse={rateInUse}
                            readOnly={readOnly}
                />
            </TabPanel>
            {dialog?.open &&
                <DialogComponent
                    type={"info"}
                    onClickConfirm={dialog.onClickConfirm}
                    setOpen={() => setDialog(null)}
                    open={dialog.open}
                    message={dialog.message}
                />
            }
            <Loading/>
        </Grid>
    );
};

export default RateContent;
